import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import Content from "../../../components/Content.tsx";
import Header from "../../../Header.tsx";
import TournamentsRankingTablesList from "../../../tournaments/RankingTables/List.tsx";

export const Route = createFileRoute('/_app/tournaments-ranking-tables/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <>
        <Header backUrl={'/tournaments/'} />
        <Content>
            <TournamentsRankingTablesList />
        </Content>
    </>
}
